/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */

/**
 * UI 표시 상태
 */
export type WorldcupMatchItemResponseUiStatus =
  (typeof WorldcupMatchItemResponseUiStatus)[keyof typeof WorldcupMatchItemResponseUiStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorldcupMatchItemResponseUiStatus = {
  BETTABLE: 'BETTABLE',
  CLOSED: 'CLOSED',
  NOT_PARTICIPATED: 'NOT_PARTICIPATED',
  WIN: 'WIN',
  LOSE: 'LOSE',
  CANCELLED: 'CANCELLED',
} as const;
